// tour.service.ts
import { Injectable, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type TourPlacement = 'top'|'right'|'bottom'|'left'|'auto';
export interface TourStep {
  id: string;                // must match tourAnchor
  title: string;
  content: string;
  placement?: TourPlacement; // default 'auto'
}

@Injectable({ providedIn: 'root' })
export class TourService {
  private anchors = new Map<string, ElementRef<HTMLElement>>();
  private steps: TourStep[] = [];
  private index = -1;

  active$ = new BehaviorSubject<boolean>(false);
  step$   = new BehaviorSubject<TourStep|null>(null);
  rect$   = new BehaviorSubject<DOMRect|null>(null);

registerAnchor(id: string, el: ElementRef<HTMLElement>) {
  console.log('[Tour] registerAnchor:', id, el.nativeElement);
  this.anchors.set(id, el);
}
unregisterAnchor(id: string) {
  console.log('[Tour] unregisterAnchor:', id);
  this.anchors.delete(id);
}
debugListAnchors() { return Array.from(this.anchors.keys()); }

  configure(steps: TourStep[]) { this.steps = steps.slice(); }

  start() {
    if (!this.steps.length) return;
    this.index = 0;
    this.active$.next(true);
    this.update();
  }

  next() { if (this.index < this.steps.length - 1) { this.index++; this.update(); } else { this.end(); } }
  prev() { if (this.index > 0) { this.index--; this.update(); } }
  end()  { this.index = -1; this.active$.next(false); this.step$.next(null); this.rect$.next(null); }

  private update() {
    const step = this.steps[this.index];
    this.step$.next(step);
    const el = this.anchors.get(step.id)?.nativeElement;
    if (!el) { this.rect$.next(null); return; }
    const rect = el.getBoundingClientRect();
    this.rect$.next(new DOMRect(
      rect.left + window.scrollX, rect.top + window.scrollY,
      rect.width, rect.height
    ));
  }

  /** Called by overlay on resize/scroll to keep position fresh */
  refreshPosition() { if (this.active$.value) this.update(); }
}
